import {
  DETECTION_EDGE,
  DETECTION_STAGE,
} from '~/modules/tools/views/AiDetectorV4/constants';

export const getDetectionStage = (result: number): DETECTION_STAGE => {
  const stage = Object.entries(DETECTION_EDGE)
    .sort(([, a], [, b]) => b - a)
    .find(([, value]) => result >= value);
  return stage ? (stage[0] as DETECTION_STAGE) : DETECTION_STAGE.FULLY_HUMAN;
};

export const getTextSpecialSymbols = (text: string): string[] => {
  const regexp = /[*#]/g;
  const matches = text.match(regexp);

  if (!matches) {
    return [];
  }

  return [...new Set(matches)];
};

export const getDetectorWordsBalance = (): number => {
  const BALANCE = {
    standard: 80000,
  };

  return BALANCE.standard;
};

export const getDetectorInputLimits = (data: {
  isNotPremium: boolean;
}): { minCount: number; maxCount: number } => {
  const LIMITS = {
    standard_min: 50,
    standard_max: 50000,
    not_premium_max: 25000,
  };

  return {
    minCount: LIMITS.standard_min,
    maxCount: data.isNotPremium ? LIMITS.not_premium_max : LIMITS.standard_max,
  };
};
